exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-menu[data-v-a8845152] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
